import Sc from './components/Sc.js';
import Request from './components/Request.js';

const request = new Request();

document.querySelectorAll('a[data-info], .info__close').forEach( ln => {
	ln.addEventListener('click', function(e){
		const link = e.target.tagName!=='A' ? e.target.closest('A') : e.target;
		const info = link.dataset.info ? document.getElementById(link.dataset.info) : link.parentNode.parentNode;
		if (!info) return;
		e.preventDefault();
		info.classList.toggle('info--open');		
		document.body.classList.toggle('noscroll');
		document.body.classList.toggle('blur');
	}, false);
});

class thirdParty {
	constructor(){
		this.init()
	}
	async init(){

		// <!-- Google Tag Manager -->
		(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
		new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
		j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
		'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
		})(window,document,'script','dataLayer','GTM-TNZZWC6');
		// <!-- End Google Tag Manager -->


		window.ga = function () { ga.q.push(arguments) }; ga.q = []; ga.l = +new Date;
		ga('create', 'UA-136613417-1', 'auto'); ga('set', 'anonymizeIp', true); ga('set', 'transport', 'beacon'); ga('send', 'pageview')

		let gajs = document.createElement("script");
		gajs.type = "text/javascript";
		gajs.async = true;
		gajs.src = "https://www.google-analytics.com/analytics.js";
		document.body.appendChild(gajs);


		//<!-- Facebook Pixel Code -->
		!function(f,b,e,v,n,t,s)
		{if(f.fbq)return;n=f.fbq=function(){n.callMethod?
		n.callMethod.apply(n,arguments):n.queue.push(arguments)};
		if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
		n.queue=[];t=b.createElement(e);t.async=!0;
		t.src=v;s=b.getElementsByTagName(e)[0];
		s.parentNode.insertBefore(t,s)}(window, document,'script',
		'https://connect.facebook.net/en_US/fbevents.js');
		fbq('init', '1412776058987377');
		fbq('track', 'PageView');
		//<!-- End Facebook Pixel Code -->
	}
}

Sc.onloads = () => {
	new thirdParty();
};